import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChavePixService {

  private URL = environment.GATEWAY + 'finances/bankdata/';
  private appKey = 'D8E2024D-9D2D-4F53-9B2F-8B59E2FD6CB3';
  private data = JSON.parse(sessionStorage.getItem('gestorCedente'));
  private body = JSON.stringify({appKey: this.appKey, managerPersonGuid: this.data.pessoa.pessoaGuid})
  constructor(private http: HttpClient) { }

  private getHeaders() {
    const headers: any = new HttpHeaders({"Content-Type": "application/json",'Authorization': 'Bearer ' + this.data.accessToken});
    return headers;
  }

  getChavePix(pessoaId: string): Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.get(`${this.URL}list/${pessoaId}`, {headers: this.getHeaders()});
  }
  getTipoChavePix(pessoaTipo: string):Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.get(`${this.URL}list/types/${pessoaTipo}`, {headers: this.getHeaders()});
  }
  postChavePix(pessoaId: string, chave: string, tipoChave: number): Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.post(`${this.URL}add/${chave}/${tipoChave}/${pessoaId}`, this.body, { headers: this.getHeaders() });
  }
  updateChavePix(pessoaId: string, chave: string, tipoChave: number): Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.put(`${this.URL}update/${chave}/${tipoChave}/${pessoaId}`,this.body, { headers: this.getHeaders() });
  }
  deleteChavePix(pessoaId: string): Observable<any>{
    let options = {
      headers: this.getHeaders(),
      body: this.body
    };
    return this.http.delete(`${this.URL}delete/${pessoaId}`, options);
  }

}
